"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var view_map_1 = require("./view-map");
var constants_1 = require("./constants");
var REQUEST_URI = constants_1.default.REQUEST_URI;
/**
 * @utils - modal utilities for getting state and selecting subview
 */
/**
 * @function getModalState
 * @param route
 * @returns string - 'closed' | 'open' | 'animate-open' | 'animate-closed'
 */
function getModalState(route) {
    var enter = route.enter, exit = route.exit, render;
    /**
     * Tests Routing
     * If both exit and enter exist, client routed
     */
    if (enter && exit) {
        if (exit.overpanel && enter.overpanel) {
            render = 'open';
        }
        else if (!exit.overpanel && enter.overpanel) {
            render = 'animate-open';
        }
        else if (exit.overpanel && !enter.overpanel) {
            render = 'animate-closed';
        }
        else {
            render = 'closed';
        }
        /**
         * If only enter exists, then server routed
         */
    }
    else if (enter && !exit) {
        if (enter.overpanel) {
            render = 'open';
        }
        else {
            render = 'closed';
        }
    }
    else {
        render = 'closed';
    }
    return render;
}
exports.getModalState = getModalState;
/**
 * @function getModalView gets the view if either enter or exit is overpanel type
 * @param route
 * @returns string - A string representation of a subview (React) component
 */
function getModalView(route) {
    var enter = route.enter, exit = route.exit, view;
    if (enter.overpanel || route.isFlow) {
        view = enter.view;
    }
    else if (exit) {
        if (exit.overpanel || route.isFlow) {
            view = exit.view;
        }
    }
    return view;
}
exports.getModalView = getModalView;
/**
 * @function getSubView gets the view if either enter or exit is not of overpanel type
 * @param props
 * @returns string - A string representation of a subview (React) component
 */
function getSubView(props) {
    var enter = props.route.enter, exit = props.route.exit, view;
    if (enter) {
        view = enter.view;
    }
    else if (exit) {
        view = exit.view;
    }
    return view;
}
exports.getSubView = getSubView;
/**
 * Mapping for views to Modal
 * @param props
 * @param viewName
 * @returns { view, header, isCloseXHidden, cancelUrl }
 */
function ModalViewsMapping(props, viewName) {
    var _a = props.route, flow = _a.enter.flow, _b = _a.isFlow, isFlow = _b === void 0 ? false : _b, 
    // default modal for all overpanel view
    modal = {
        header: undefined,
        view: undefined,
        isCloseXHidden: isFlow,
        cancelUrl: undefined
    };
    if (isFlow) {
        modal.cancelUrl = REQUEST_URI + "/flow-cancel/" + flow;
    }
    // name string of the view that will be mapped to react template
    var view = view_map_1.default[viewName];
    modal = view ? Object.assign(modal, view) : undefined;
    return modal;
}
exports.ModalViewsMapping = ModalViewsMapping;
/**
 * Maps the view type to it's modal props using modal.mapping
 * @param props
 * @returns { view, header, isCloseXHidden, cancelUrl }
 */
function modalViewSelection(props) {
    return ModalViewsMapping(props, getModalView(props.route)); // eslint-disable-line new-cap
}
exports.modalViewSelection = modalViewSelection;
